export default {
  data() {
    return {
      activeIndex: 0,
      sceneList: [{
        name: "开屏广告",
        content: "头部品牌广告主青睐样式，广告点击率，填充率更高，变现能力更出色",
        tips: ["应用启动页", "支持图片、视频"],
        imgs: ["scene-1.png", "scene-2.png", "scene-3.png"]
      }, {
        name: "视频激励广告",
        content: "观看视频广告以免费获得奖励，沉浸式广告体验，广告点击率转化率极高",
        tips: ["获取应用内奖励及权益体系的所有应用及场景", "支持15~60秒竖版视频、横版视频"],
        imgs: ["scene-4.png", "scene-5.png", "scene-6.png"]
      }],
      isAnimated: false,
      animationClass: []
    };
  },
  methods: {
    getImagePath(type, imageName) {
      if (type == 0) {
        return require(`../../assets/images/scenebj-${imageName + 1}.jpg`);
      } else {
        return require(`../../assets/images/${imageName}`);
      }
    },
    onTabChange(index) {
      this.offAnimationClass();
      if (this.activeIndex == index) {
        return;
      }
      this.activeIndex = index;
      // this.animationClass = ["animate__animated", "animate__slideInRight"];
      setTimeout(() => {
        this.offAnimationClass();
      }, 1000);
    },
    offAnimationClass() {
      this.animationClass = [];
    },
    onEnter(el, done) {
      // 进入动画 - 淡入
      el.style.opacity = "0";
      el.style.transition = "opacity 0.3s ease-in-out";

      // 强制重绘
      el.offsetHeight;
      el.style.opacity = "1";
      setTimeout(done, 300);
    },
    onLeave(el, done) {
      // 离开动画 - 淡出
      el.style.transition = "opacity 0.1s ease-in-out";
      el.style.opacity = "0";
      setTimeout(done, 100);
    }
  }
};